import { Navigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext);

  //console.log('AdminRoute state:', { isAuthenticated, userRole: user?.role, loading }); // Debug log

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Debug log removed — was leaking auth state to console.
    return <Navigate to="/login" />;
  }

  if (!user || user.role !== 'admin') {
    //console.log('Not admin, redirecting to unauthorized');
    return <Navigate to="/unauthorized" />;
  }

  return children;
};